<div class="chat-history-container" *ngIf="chatHistoryList?.length > 0 && !isLoadingHistory" (scroll)="onScroll($event)">
    <div class="chat-history-item" *ngFor="let historyItem of displayedHistoryList; trackBy: trackByChatId"
        (click)="loadChatHistory(historyItem)">
        <div class="history-item-header" *ngIf="historyItem.Title">
            <span class="history-date">{{historyItem.displayDate}}</span>
            <span class="history-title">{{historyItem.Title}}</span>
        </div>
    </div>

    <!-- Loading Indicator -->
    <div class="loading-indicator" *ngIf="isLoading">
        <div class="spinner default-chat-loader">
            <nalco-refresh-loader [isLoading]="isLoading"></nalco-refresh-loader>
        </div>
    </div>

    <!-- End of List Indicator -->
    <div class="end-of-list" *ngIf="!hasMoreItems && displayedHistoryList?.length > initialHistoryCount">
        <span>{{'AI_AGENT.NO_MORE_HISTORY' | translate}}</span>
    </div>
</div>

<div class="loading-indicator" *ngIf="!chatHistoryList?.length && isLoadingHistory"
    style="text-align: center; padding: 10px;">
    <div class="spinner">
        <nalco-refresh-loader [isLoading]="isLoadingHistory"></nalco-refresh-loader>
    </div>
</div>

<!-- No History Message -->
<div class="no-history-message" *ngIf="chatHistoryList?.length === 0">
    <img src="../../../../assets/images/ai-agent/Icon-Communication.svg" class="no-history-icon" />
    <p>{{'AI_AGENT.NO_AVAILABLE_CHAT' | translate}}</p>
    <span>{{'AI_AGENT.START_NEW_CONVERSATION' | translate}}</span>
</div>